export default __webpack_public_path__ + "static/media/8.76fbd6b2.webp";